import { IndividualSex } from '@/shared/vaccination/enums';

export type Dictionaries = Record<keyof typeof Dictionary, DictionaryItem[]>;

export const Dictionary = {
  DRUG_TYPE: 'DRUG_TYPE',
  RESEARCH_TYPE: 'RESEARCH_TYPE',
  APPLICATION_TYPE: 'APPLICATION_TYPE',
  ANIMAL_SPECIES: 'ANIMAL_SPECIES',
  ADMINISTRATION_ROUTE: 'ADMINISTRATION_ROUTE',
  INDIVIDUAL_LOCATION: 'INDIVIDUAL_LOCATION',
  DRUG: 'DRUG',
  EVENT_PROTOCOL_TYPE: 'EVENT_PROTOCOL_TYPE',
  EVENT_PROTOCOL: 'EVENT_PROTOCOL',
  ANIMAL_SPECIES_TRANSITION: 'ANIMAL_SPECIES_TRANSITION',
} as const;

export interface DictionaryItem {
  id: string;
  name: string;
}

/** Элемент словаря EVENT_PROTOCOL_TYPE (тип схемы мероприятий). */
export interface EventProtocolTypeDictionaryItem extends DictionaryItem {
  orderNumber?: number;
  /** Группа (вид) животных, для которой предназначена схема; null — для всех групп. */
  animalSpeciesId?: string | null;
}

/** Переход особи из одной группы (вида) животных в другую по достижении возраста. */
export interface AnimalSpeciesTransition {
  id: string;
  status?: 'ACTIVE' | 'DELETED';
  fromSpeciesId: string;
  /** Пол, для которого действует переход; null — для любого пола. */
  sex: IndividualSex | null;
  toSpeciesId: string;
  maxAgeDays: number;
}

export type AnimalSpeciesTransitionPayload = Omit<
  AnimalSpeciesTransition,
  'id' | 'status'
> & {
  id?: string;
};

export type EventProtocolTypePayload = {
  id: string;
  name: string;
  orderNumber?: number;
  animalSpeciesId: string | null;
};

export type TransformedDictionaries = {
  [K in keyof typeof Dictionary]: {
    [id: string]: DictionaryItem;
  };
};
export type DictMap = {
  dictMap: TransformedDictionaries;
};
